import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import OnboardingPhone from './OnboardingPhone';
import {
  type OnboardingPhoneFormValues,
  initialValues,
  validationSchema,
} from './schema';

const OnboardingPhoneContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const onSubmit = (values: OnboardingPhoneFormValues) => {
    user.setMobilePhone(values.mobilePhone.replace(/\D/g, ''));
    navigate(Routes.ONBOARDING_CEP);
  };
  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <OnboardingPhone />
    </FormBehavior>
  );
};

export default observer(OnboardingPhoneContainer);
